import { dateFormat, getClientBreadCrumbs, successMessageToast, userFullName } from "helpers/common";
import { useEffect, useMemo, useRef, useState } from "react";
import { Button, Col, Container, Dropdown, Form, Row } from "react-bootstrap";
import { generatePath, useNavigate, useParams } from "react-router-dom";
import LoadingIndicator from "components/shared/LoadingIndicator";
import LoadingOverlay from "components/shared/LoadingOverlay";
import { SCHOOL_CLIENT_DETAIL, SCHOOL_CLIENT_LIST } from "config/paths";
import { Breadcrumbs, CommonToolTip, CstmPagination, NoRecordFoundV2 } from "components/Common/Common";
import { useGetSchoolClientDataQuery } from "store/services/clients/school.client";
import downArrow from "Assets/images/downArro.png"
import rightArrow from "Assets/images/rightArro.png"
import { useGetHomeEducationClientDetailsQuery } from "store/services/clients/homeEducation.client";
import { usePrivateClientDetailsQuery } from "store/services/clients/private.client";
import AttendanceTrackerModal from "components/Modals/AttendanceTrackerModal";
import { DeleteIcon, EditIcon, PlusIcon2 } from "Assets/icons";
import { Delete, Edit, Edit2 } from "react-feather";
import { useDeleteAttendanceMutation, useUpdateAttendanceMutation } from "store/services/attendance";
import confirmDialogV2 from "utils/confirmationDialogV2";
import AddPlus from "Assets/images/AddPlus";

const AttendanceTracker = ({ }) => {
    const navigate = useNavigate()
    const { clientId, clientType } = useParams();
    const [attendanceModal, setAttendanceModal] = useState(false);
    const [currentCaseload, setCurrentCaseload] = useState(null);

    const dropdownRef = useRef(null);

    const { data: clientDetails, isLoading, isFetching, refetch } = clientType == "school" ? useGetSchoolClientDataQuery(clientId) : clientType == "private" ? usePrivateClientDetailsQuery(clientId) : useGetHomeEducationClientDetailsQuery(clientId);
    const clientCaseloadTherapist =
        clientDetails?.clientCaseloads
            // Only the regular caseload belongs on the client detail page; MDT caseloads are managed on the MDT screens
            ?.filter(c => c?.case_type === "regular")
            ?.flatMap(c => c.clientCaseloadTherapist) || [];

    const isDischarged = clientDetails?.status == 'discharged'
    const isInactive = clientDetails?.status == 'inactive'

    const [updateAttendance, { isLoading: updateAttendanceLoading }] = useUpdateAttendanceMutation();
    const [deleteAttendance, { isLoading: deleteAttendanceLoading }] = useDeleteAttendanceMutation();

    // const breadcrumbItems = [
    //     { label: "School Client", path: SCHOOL_CLIENT_LIST },
    //     { label: userFullName(clientDetails) || "Client Details", path: generatePath(SCHOOL_CLIENT_DETAIL, { id: clientId }) },
    //     { label: "Attendance Details" },
    // ];

    const breadcrumbItems = useMemo(() => getClientBreadCrumbs(clientId, clientType, clientDetails, "Attendance Details"), [clientType, clientDetails, clientId]);


    const [openDiscipline, setOpenDiscipline] = useState(null);

    const toggleDiscipline = (id) => {
        setOpenDiscipline(prev => prev === id ? null : id);
    };

    const handleAttendanceChange = async (session, value) => {
        try {
            if (value === session?.attendance) {
                return;
            }
            const result = await updateAttendance({ attendanceId: session?.id, attendance: value, session_date: session?.session_date });
            if (!result?.error) {
                successMessageToast(result?.data?.message);
                refetch();
            }
        } catch (error) {
            console.log("Error update attendance", error);
        };
    };

    const handleDelete = async (session) => {
        try {
            const isConfirm = await confirmDialogV2();
            if (!isConfirm) {
                return;
            }
            if (!deleteAttendanceLoading) {

                const result = await deleteAttendance(session?.id);
                if (!result?.error) {
                    successMessageToast(result?.data?.message);
                    refetch();
                }
            };
        } catch (error) {
            console.log("Error delete attendance", error);
        };
    };

    return (
        <>
            <AttendanceTrackerModal
                show={attendanceModal}
                setShow={setAttendanceModal}
                refetch={refetch}
                caseLoadId={currentCaseload?.id}
            // closeCallback={() => setCurrentCaseload(null)}
            />
            {
                isLoading ? <LoadingIndicator /> : <div className="">
                    {(isFetching || updateAttendanceLoading || deleteAttendanceLoading) && <LoadingOverlay />}
                    <section
                        className={`position-relative ClientDetail`}
                    >
                        <Container fluid>
                            <Row className="pt-3" style={{ paddingLeft: "12px" }}>
                                <Col lg="6">
                                    <Breadcrumbs themeBlueV2 items={breadcrumbItems} />
                                </Col>
                            </Row>
                            <div style={{ padding: "12px", borderRadius: "4px" }}>

                                <Row className="justify-content-between" >
                                    <Col lg='9'>
                                        <p className="twenty proxima-regular mb-0" style={{ color: "#000" }}>
                                            Attendance Details
                                        </p>
                                    </Col>
                                    <Col lg='2' style={{ textAlign: "center" }}>

                                    </Col>
                                </Row>
                                {
                                    clientCaseloadTherapist?.length > 0 ? <div className="mt-2">

                                        <table className="w-100">
                                            <thead>
                                                <tr>
                                                    <th className="fw-medium w-50" style={{ padding: "15px 10px", borderBottom: "2px solid #315D99" }}>
                                                        DISCIPLINE
                                                    </th>
                                                    <th className="fw-medium text-center" style={{ padding: "15px 10px", borderBottom: "2px solid #315D99" }}>
                                                        TOTAL ATTENDED
                                                    </th>
                                                    <th className="fw-medium text-center" style={{ padding: "15px 10px", borderBottom: "2px solid #315D99" }}>
                                                        TOTAL SCHEDULED
                                                    </th>
                                                    <th className="fw-medium text-center" style={{ padding: "15px 10px", borderBottom: "2px solid #315D99" }} ></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {clientCaseloadTherapist?.map((item) => {
                                                    return (
                                                        <>
                                                            <tr onClick={() => toggleDiscipline(item.id)} style={{ backgroundColor: "#F8F8F8" }}>
                                                                <td style={{ padding: "15px 10px", borderRadius: "0", borderBottom: "1px solid #8F8F8F", }}>
                                                                    <span className={`discipline-${item?.caseDiscipline?.assign_term}-capsule-bcg`} style={{ padding: "7px 10px", marginRight: "3px", borderRadius: "8px" }}>{item?.caseDiscipline?.assign_term}</span>
                                                                </td>
                                                                <td className="text-center" style={{ padding: "15px 10px", borderRadius: "0", borderBottom: "1px solid #8F8F8F" }}>{item?.caseloadSessions?.filter(x => x.attendance == "present")?.length}</td>
                                                                <td className="text-center" style={{ padding: "15px 10px", borderRadius: "0", borderBottom: "1px solid #8F8F8F" }}>
                                                                    {item?.caseloadSessions?.length}
                                                                </td>
                                                                <td className="text-center " style={{ padding: "15px 10px", borderBottom: "1px solid #8F8F8F" }}>
                                                                    <Button
                                                                        className="border-0 p-0 me-3 icon-btn"
                                                                        variant="transparent"
                                                                        disabled={isDischarged || isInactive}
                                                                    >
                                                                        <AddPlus height="25px" width="25px" onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            setAttendanceModal(true);
                                                                            setCurrentCaseload(item);
                                                                        }} />
                                                                    </Button>
                                                                    <img
                                                                        src={openDiscipline === item.id ? downArrow : rightArrow}
                                                                        width={openDiscipline === item.id ? 12 : 7}
                                                                        alt="toggle"
                                                                    />
                                                                </td>
                                                            </tr>
                                                            {openDiscipline === item.id &&
                                                                item.caseloadSessions?.map((session) => {
                                                                    const therapist = item?.clientCaseloadMapping?.find((x) => x?.caseTherapist?.therapist_detail?.type == "veteran")
                                                                    return (
                                                                        <tr style={{ backgroundColor: "white" }}>
                                                                            <td style={{ padding: "15px 10px", borderBottom: "1px solid #8F8F8F", borderRadius: "0" }}>
                                                                                <div className="d-flex align-items-center gap-10">
                                                                                    <AttendanceDropdown
                                                                                        session={session}
                                                                                        onChange={handleAttendanceChange}
                                                                                        onDelete={handleDelete}
                                                                                        disabled={isDischarged || isInactive}
                                                                                    />
                                                                                </div>
                                                                            </td>
                                                                            <td colSpan={2} style={{ padding: "15px 10px", borderBottom: "1px solid #8F8F8F", borderRadius: "0" }}>

                                                                                <span style={{ marginLeft: '50px' }} className="">{dateFormat(session?.session_date, "MMM DD, YYYY")}</span>
                                                                            </td>
                                                                            <td style={{ padding: "15px 10px", borderBottom: "1px solid #8F8F8F", borderRadius: "0", textAlign: "center" }}>
                                                                                <Button
                                                                                    className="p-0 icon-btn"
                                                                                    variant="transparent"
                                                                                    type="button"
                                                                                    onClick={() => {
                                                                                        handleDelete(session)
                                                                                    }}
                                                                                    disabled={isDischarged || isInactive}
                                                                                >

                                                                                    <DeleteIcon
                                                                                        fill="#071e3e"
                                                                                        height="25px"
                                                                                        width="25px"
                                                                                    />
                                                                                </Button>
                                                                            </td>
                                                                        </tr>
                                                                    )
                                                                })
                                                            }
                                                        </>
                                                    )
                                                })
                                                }
                                            </tbody>
                                        </table>

                                        {/* <CstmPagination
                                            totalPages={totalPages}
                                            activePage={currentPage}
                                            className="paginationV2"
                                            handlePageChange={handlePageChange}
                                        /> */}
                                    </div> : <NoRecordFoundV2 message="No Record Found." />
                                }
                            </div>
                        </Container>
                    </section>
                </div>
            }
        </>
    );

};

const AttendanceDropdown = ({ session, onChange, disabled }) => {
    const [openId, setOpenId] = useState(null);

    const dropdownRef = useRef();

    useEffect(() => {
        const handleClickOutside = (event) => {
            console.log(dropdownRef.current, event.target, dropdownRef.current.contains(event.target))
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target)
            ) {
                setOpenId(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <div className="dropdown" ref={dropdownRef}>
            <div className="d-flex align-items-center gap-2">
                <span className="text-capitalize themeBlue">{session?.attendance ?? "select"}</span>
                <button
                    className="btn btn-sm btn-transparent text-capitalize icon-btn p-0"
                    type="button"
                    onClick={() =>
                        setOpenId(openId === session.id ? null : session.id)
                    }
                    disabled={disabled}
                >
                    <EditIcon height="25px" width="25px" />
                </button>
            </div>

            {openId === session.id && (
                <ul className="dropdown-menu show">
                    <li>
                        <button
                            className="dropdown-item text-capitalize"
                            onClick={() => {
                                console.log("onclick button")
                                onChange(session, "present");
                                setOpenId(null);
                            }}
                        >
                            Present
                        </button>
                    </li>
                    <li>
                        <button
                            className="dropdown-item text-capitalize"
                            onClick={() => {
                                onChange(session, "absent");
                                setOpenId(null);
                            }}
                        >
                            Absent
                        </button>
                    </li>
                </ul>
            )}
        </div>
    )
}

export default AttendanceTracker;